import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CountryStatesIndraService {

	constructor(
		private http: HttpClient
	) { }

	public getCountryConversionCodes(): Observable<any> {
		const URL = './assets/data/indra_code_conversion.json';
		return this.http.get(URL);
	}

	public getCountryCodes(): Observable<any> {
		const URL = './assets/data/indra_country_codes.json';
		return this.http.get(URL);
	}

	public getUSStates(): Observable<any> {
		const URL = './assets/data/indra_us_states.json';
		return this.http.get(URL);
	}

	public getUSAirports(): Observable<any> {
		const URL = './assets/data/indra_us_airports.json';
		return this.http.get(URL);
	}

	public getSchengenCountryCodes(): Observable<any> {
		const URL = './assets/data/indra_schengen_codes.json';
		return this.http.get(URL)
	}

	public getEUCountryCodes(): Observable<any> {
		const URL = './assets/data/indra_eu_codes.json';
		return this.http.get(URL);
	}

}
